export default __webpack_public_path__ + "d76d91039ba0011703a56ae5a014f395.png";